<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Kontak {{ url[1] }} list</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/master/kontak/kontak-baru')" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Kontak Baru</a>
            </div>
          </div>
        <div class="section-body">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                    <div class="card-header">
                        <h4>Daftar Kontak {{ url[1] }}</h4>
                        <div class="card-header-form">
                            <div class="input-group">
                            <input type="text" class="form-control" v-model="filter" @keyup.enter="setFilter()" placeholder="Search">
                            <div class="input-group-btn">
                                <button @click="setFilter()" class="btn btn-primary"><i class="fas fa-search"></i></button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                        <table class="table table-hover table-bordered table-md">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Tipe Kontak</th>
                                    <th>Alamat</th>
                                    <th>No. Telepon</th>
                                    <th>Nama Kontak</th>
                                    <th>Perusahaan</th>
                                    <th>Nama Pemilik</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="cursor:pointer;" v-for="list in kontakList" v-bind:key="list.main.id_kontak" @click="goDetail(list.main.id_kontak)">
                                    <td>{{ list.no }}</td>
                                    <td>{{ list.main.tipe_kontak }}</td>
                                    <td>{{ list.main.alamat }}</td>
                                    <td>{{ list.main.nomor_tlp }}</td>
                                    <td>{{ list.main.display_name }}</td>
                                    <td>{{ list.main.company_name }}</td>
                                    <td>{{ list.main.nama_pemilik }}</td>
                                </tr>
                            </tbody>
                            
                        </table>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <nav class="d-inline-block">
                        <ul class="pagination mb-0">
                            <li class="page-item disabled">
                                <a class="page-link" href="#" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                            </li>
                            <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#"><i class="fas fa-chevron-right"></i></a>
                            </li>
                        </ul>
                        </nav>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
import Vue from 'vue'

export default {
    data() {
        return {
            kontakList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : ''
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = true;
            this.$http.get("Kontak/getKontakTable/"+this.url[1]+"?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get kontak '+this.url[1])
                }
                else {
                    this.kontakList = result.data.detail.data;
                    this.totalRow = result.data.detail.totalRow;
                    this.last = Math.ceil(this.totalRow / this.perPage)
                    this.pagination = this.getPaging();
                }
                this.$root.is_loading = false;
			}, error => {
                this.$root.is_loading = false;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.replace({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetail: function(id_kontak){
            var u = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            this.$router.replace({ path : 'kontak/kontak-detail/'+id_kontak })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        statusBayarCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        setFilter: function() {
            this.init();
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/kontak/KontakList.vue